import { PageTab } from "../page-tab"

export class SwapOverviewTab extends PageTab {
  readonly id = "overview"
  readonly label = "Swap"
  readonly hrefTemplate = "/swap"
}

export class SwapSettingsTab extends PageTab {
  readonly id = "settings"
  readonly label = "Settings"
  readonly hrefTemplate = "/swap/settings"
}
